const isNum = (value) => value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value));

export function formatRiskValue(value, format) {
  if (!isNum(value)) return '—';
  const n = Number(value);
  switch (format) {
    case 'signedPercent':
      return `${n > 0 ? '+' : ''}${(n * 100).toFixed(1)}%`;
    case 'percent':
      return `${(n * 100).toFixed(1)}%`;
    case 'signedInteger':
      return `${n > 0 ? '+' : ''}${Math.round(n).toLocaleString()}`;
    case 'integer':
      return Math.round(n).toLocaleString();
    case 'oneDecimal':
      return n.toFixed(1);
    case 'abBinary':
      // 1 = A/B letter grade, 0 = C/D/F; peer medians can land in between.
      if (n === 1) return 'A/B';
      if (n === 0) return 'C–F';
      return `${Math.round(n * 100)}% A/B`;
    default:
      return n.toFixed(2);
  }
}

const WHOLE_PERCENT_FORMATS = { signedPercent: true, percent: true };

/**
 * Like formatRiskValue, but percentages round to the nearest whole number
 * (the profile drawer reads cleaner without decimals). A change that rounds
 * to zero shows as "0%", never "-0%".
 */
export function formatWholeRiskValue(value, format) {
  if (!WHOLE_PERCENT_FORMATS[format] || !isNum(value)) return formatRiskValue(value, format);
  const rounded = Math.round(Number(value) * 100);
  if (format === 'percent' || rounded === 0) return `${rounded === 0 ? 0 : rounded}%`;
  return `${rounded > 0 ? '+' : ''}${rounded}%`;
}

export function formatPoints(points) {
  return isNum(points) ? Number(points).toFixed(0) : '—';
}

export function gradeLabel(grade) {
  if (!isNum(grade)) return '—';
  return Number(grade) === 0 ? 'K' : `Grade ${grade}`;
}
